//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import httpHelper from '../../common/helpers/HttpHelper';
import environments from '../../common/environments/environment';
const http = new httpHelper();


export const ManageClientsActions = {
    GetManageClientsJSON: getManageClientsJSON,
    GetClientProfileJSON: getClientProfileJSON,
    GetEditExistingClientsJSON: getEditExistingClientsJSON,
    GetManageClientsList: getManageClientsList,
    GetClientProfile: getClientProfile,
    GetProgramSetupList: getProgramSetupList,
    SaveProgramSetupList: saveProgramSetupList,
    DeleteProgramSetupList: deleteProgramSetupList,
    TrackAction: trackAction,
    getAdminClientsCMSContent: getAdminClientsCMSContent,
    returnLabel: returnLabel
}

function trackAction(payload) {
    return http.adminPost(environments.TRACK_ADMIN_ACTIONS, payload);
}

function getManageClientsJSON() {
    return http.jsonGet(environments.CONTAINER_NAME + environments.MANAGE_CLIENTS_JSON);
}

function getClientProfileJSON() {
    return http.jsonGet(environments.CONTAINER_NAME + environments.CLIENT_PROFILE_JSON);
}

function getEditExistingClientsJSON() {
    return http.jsonGet(environments.CONTAINER_NAME + environments.EDIT_EXISTING_CLIENTS_JSON);
}

function getClientProfile(clientCode, countryCode, personaId) {
    let refCountryCode = environments.CLIENT_PROFILE + "?ClientCode=" + clientCode + "&&CountryCode=" + countryCode + "&PersonaId=" + personaId;
    return http.adminGet(refCountryCode);
}

function getProgramSetupList(programClassId) {
    let refGetProgramSetup = environments.CLIENT_PROGRAM_SETUP_LIST.replace("{ProgramClassId}", programClassId);
    return http.adminGet(refGetProgramSetup);
}

function getManageClientsList() {
    return http.adminGet(environments.MANAGE_CLIENTS);
}

function saveProgramSetupList(programClassId, payload) {
    let refSaveProgramSetup = environments.CLIENT_PROGRAM_SETUP_LIST.replace("{ProgramClassId}", programClassId);
    return http.adminPut(refSaveProgramSetup, payload);
}

function deleteProgramSetupList(programClassId) {
    let refDeleteProgramSetup = environments.CLIENT_PROGRAM_SETUP_LIST.replace("{ProgramClassId}", programClassId);
    return http.adminDelete(refDeleteProgramSetup);
}

function getAdminClientsCMSContent(payload) {
    return http.CMSpost(environments.ADMIN_PAGE_DETAILS, payload);
}

function returnLabel(labelArray = [], key) {
    return labelArray.find((x) => x.Key === key)?.Phrase || '';
}
